export default function HVACHero() {
  return (
    <section className="relative bg-gradient-to-br from-orange-50 to-orange-100 pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-orange-600 text-white text-sm font-medium rounded-full mb-6">
              El Paso HVAC Experts
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Find Top-Rated HVAC Contractors in El Paso, TX
            </h1>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              Connect with licensed and insured HVAC professionals for installation, repair, and maintenance. Get free quotes from trusted contractors serving El Paso and surrounding areas.
            </p>
            <div className="flex flex-wrap gap-4">
              <a 
                href="#directory" 
                className="px-8 py-4 bg-orange-600 text-white font-semibold rounded-lg hover:bg-orange-700 transition-colors shadow-lg whitespace-nowrap"
              >
                Find HVAC Contractors
              </a>
              <a 
                href="#services" 
                className="px-8 py-4 bg-white text-orange-600 font-semibold rounded-lg hover:bg-gray-50 transition-colors border-2 border-orange-600 whitespace-nowrap"
              >
                View Services
              </a>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/74253c891dc68457580553ddc064b0e9.jpg"
              alt="HVAC Contractors El Paso"
              className="w-full h-[500px] object-cover object-top rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
